<template>
  <div
    class="record"
    :style="
      recordList && recordList.length > 2 ? 'height: auto;' : 'height: 570px;'
    "
  >
    <div class="record-title">
      <van-search
        v-model="order.keyWord"
        placeholder="搜索诉求标题"
        @input="searchOrder"
      />
      <van-tabs
        v-model="order.process"
        color="#0084FF"
        :line-width="100"
        title-active-color="#0084FF"
        :before-change="onClickTab"
      >
        <van-tab title="全部"> </van-tab>
        <van-tab title="受理中"></van-tab>
        <van-tab title="已完结"></van-tab>
        <van-tab title="已评价"></van-tab>
      </van-tabs>
    </div>
    <div class="record-total">共有{{ total }}条述求</div>

    <div class="record-ul" v-if="recordList && recordList.length > 0">
      <van-pull-refresh
        v-model="isLoading"
        @refresh="onRefresh"
        :style="
          recordList && recordList.length > 2
            ? 'height: auto;'
            : 'height: 480px;'
        "
      >
        <van-list
          v-model="isUpLoading"
          :finished="upFinished"
          @load="onLoad"
          :offset="offset"
          :finished-text="textBottom"
        >
          <div
            class="record-list"
            v-for="(item, index) in recordList"
            :key="index"
            @click="orderDetail(item.id)"
          >
            <!-- 已完结 record-list-closed 已受理 record-list-accepted -->
            <div
              :class="[
                'record-list-title',
                item.currentProcess === 2
                  ? 'record-list-closed'
                  : item.currentProcess === 3
                  ? 'record-list-accepted'
                  : ''
              ]"
            >
              <span>{{ item.createTime }}</span>
              <div>{{ item.currentProcess | processStatus }}</div>
            </div>
            <div class="record-list-content">
              <div class="record-list-content-ps">
                {{ item.appealTitle }}
              </div>
              <div>
                <i></i> <span>{{ item.entName }}</span>
              </div>
            </div>
            <div class="record-list-evaluate" v-if="item.currentProcess === 2">
              <i></i>
              评价
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <van-empty v-else description="暂无诉求" />
  </div>
</template>

<script>
import { newSaveRecord, newSaveUVRecord } from '@api/lishui'
import { getLocalStorage } from '@utils'
import { appealList } from '@api/myAppeal/index'
export default {
  data() {
    return {
      recordList: [],
      order: {
        keyWord: '',
        process: '',
        current: 0,
        size: 10
      },
      total: 0,
      userInfo: getLocalStorage('lishuiUserInfo')
        ? JSON.parse(getLocalStorage('lishuiUserInfo'))
        : {},
      isLoading: false, // 下拉刷新
      isUpLoading: false, // 上拉加载
      upFinished: false, // 上拉加载完毕
      finished: false,
      offset: 100, // 滚动条与底部距离小于 offset 时触发load事件
      textBottom: '没有更多了~'
    }
  },
  filters: {
    processStatus(val) {
      let value = ''
      switch (val) {
        case 1:
          value = '受理中'
          break
        case 2:
          value = '已完结'
          break
        case 3:
          value = '已评价'
          break

        default:
          break
      }
      return value
    }
  },
  mounted() {
    this.dataList()
  },
  methods: {
    // 埋点
    buriedPoint() {
      const params = {
        applyName: this.$route.meta.title,
        creditCode: this.userInfo.creditCode,
        entName: this.userInfo.entName,
        mobile: this.userInfo.mobile
      }
      JSSDK_QYM.sendData({
        pageUrl: this.$route.path,
        pageId: window.location,
        pageName: this.$route.meta.title,
        userAgent: ''
      })
      newSaveRecord(params).then(res => {})
      newSaveUVRecord(params).then(res => {})
    },
    // 下拉调用此函数
    onRefresh() {
      setTimeout(() => {
        this.$toast('刷新成功') // 弹出
        this.isLoading = false
      }, 500)
    },
    // 上拉调用此函数
    onLoad() {
      setTimeout(() => {
        this.isUpLoading = false
        this.dataList()
      }, 500)
    },
    onClickTab(title) {
      this.order.process = title === 0 ? '' : title
      this.order.current = 0
      this.recordList = []
      this.dataList()
    },
    searchOrder() {
      this.order.current = 0
      this.recordList = []
      this.dataList()
    },
    dataList() {
      this.order.current++
      this.order.process = this.order.process === 0 ? '' : this.order.process
      appealList(this.order).then(res => {
        if (res.data) {
          let lists = res.data.data.records || []
          this.total = res.data.data.total
          if (lists.length === 0) {
            this.upFinished = true
          } else {
            this.upFinished = false
          }
          for (var i = 0; i < lists.length; i++) {
            this.recordList.push(lists[i]) // 上拉时循环出来这个数组的三条内容，放入datacontent这个数组里，那样就一直拉一直加
          }
        }
      })
    },
    orderDetail(id) {
      this.buriedPoint()
      this.$router.push({ name: 'appealDetails', query: { id: id }})
    }
  }
}
</script>

<style lang="scss" scoped>
.record {
  background-color: #f8f9fc;
  &-ul {
    padding: 15px;
  }
  &-list {
    margin-bottom: 10px;
    background-color: #fff;
    &-title {
      height: 42px;
      line-height: 42px;
      display: flex;
      justify-content: space-between;
      padding: 0 15px;

      border-bottom: 1px solid rgba(243, 243, 243, 1);
      span {
        color: rgba(102, 102, 102, 100);
        font-size: 14px;
      }
      > div {
        margin-top: 10px;
        width: 52px;
        height: 22px;
        line-height: 22px;
        border-radius: 3px;
        background-color: rgba(0, 146, 255, 0.1);
        color: rgba(0, 132, 255, 100);
        font-size: 14px;
        text-align: center;
      }
    }
    &-closed {
      > div {
        background-color: rgba(0, 0, 0, 0.1);
        color: #666666;
      }
    }
    &-accepted {
      > div {
        background-color: rgba(0, 213, 139, 0.1);
        color: #00d58b;
      }
    }
    &-content {
      padding: 0 15px;
      &-ps {
        padding: 10px 0;
        height: 30px;
        line-height: 24px;
        letter-spacing: 1px;
        overflow: hidden;
        color: rgba(48, 49, 51, 100);
        font-size: 18px;
        display: -webkit-box; //将对象作为弹性伸缩盒子模型显示。
        -webkit-box-orient: vertical; //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
        -webkit-line-clamp: 2; //规定行数
      }
      > div {
        padding-bottom: 20px;

        i {
          display: inline-block;
          width: 16px;
          height: 14px;
          background: url('../../../assets/myAppeal/floor.png') no-repeat;
          background-size: 100%;
        }
        span {
          margin-left: 6px;
          color: rgba(102, 102, 102, 100);
          font-size: 14px;
        }
      }
    }
    &-evaluate {
      border-top: 1px solid rgba(243, 243, 243, 1);
      height: 45px;
      line-height: 45px;
      color: rgba(0, 132, 255, 100);
      font-size: 16px;
      text-align: center;
      i {
        display: inline-block;
        width: 15px;
        height: 15px;
        background: url('../../../assets/myAppeal/evaluate.png') no-repeat;
        background-size: 100%;
      }
    }
  }
  &-title {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
  }
  &-total {
    padding-left: 15px;
    padding-top: 10px;
    margin-top: 100px;
    font-size: 14px;
    color: rgba(102, 102, 102, 100);
  }
}
/deep/.van-tab__text {
  font-size: 16px;
}
/deep/ .van-empty {
  height: 536px;
}
</style>
